import { useState } from "react";
import { Box, IconButton, Modal, SxProps, Theme, styled } from "@mui/material";
import { Close } from "@mui/icons-material";

interface ImagePreviewProps {
    src?: any;
    alt?: string;
    sx?: SxProps<Theme>;
    style?: React.CSSProperties;
    onError?: (e: React.SyntheticEvent<HTMLImageElement>) => void;
}

const StyledImg = styled("img")({
    cursor: "pointer",
    transition: "transform 0.2s ease-in-out",
    "&:hover": {
        transform: "scale(1.02)",
    },
});

export const ImagePreview = ({ src, alt = "", sx, style, onError }: ImagePreviewProps) => {
    const [isOpen, setIsOpen] = useState(false);

    const handleOpen = (e: React.MouseEvent) => {
        e.stopPropagation();
        setIsOpen(true);
    };

    const handleClose = (e: React.MouseEvent) => {
        e.stopPropagation();
        setIsOpen(false);
    };

    if (!src) return null;

    return (
        <>
            <StyledImg
                src={src || ""}
                alt={alt}
                onClick={handleOpen}
                sx={sx}
                style={style}
                onError={onError}
            />

            <Modal
                open={isOpen}
                onClose={handleClose}
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    bgcolor: "rgba(0, 0, 0, 0.9)",
                    zIndex: 9999,
                }}
            >
                <Box
                    sx={{
                        position: "relative",
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        p: 2,
                    }}
                    onClick={handleClose}
                >
                    <IconButton
                        onClick={handleClose}
                        sx={{
                            position: "absolute",
                            top: 20,
                            right: 20,
                            color: "#fff",
                            bgcolor: "rgba(0, 0, 0, 0.5)",
                            "&:hover": {
                                bgcolor: "rgba(0, 0, 0, 0.7)",
                            },
                            zIndex: 10000,
                        }}
                    >
                        <Close fontSize="large" />
                    </IconButton>

                    <Box
                        component="img"
                        src={src || ""}
                        alt={alt}
                        sx={{
                            maxWidth: "100%",
                            maxHeight: "100%",
                            objectFit: "contain",
                            userSelect: "none",
                        }}
                        onClick={(e) => e.stopPropagation()}
                    />
                </Box>
            </Modal>
        </>
    );
};
